import React from 'react';
import cls from 'classnames';

import IconFont from '@/components/IconFont';

import styles from './index.module.scss';

const Index = (props) => {
  const { value, onChange, options } = props;

  // 选择
  const handleItemClick = (item) => {
    if (item.id === value) return;
    onChange(item.id);
  };

  if (options && options.length > 1) {
    return (
      <div className={styles.methodSwitchWrapper}>
        {options.map((item) => {
          return (
            <div
              className={cls(styles.methodItem, item.id === value ? styles.methodItemActive : null)}
              key={item.id}
              onClick={() => handleItemClick(item)}
            >
              <IconFont className={styles.methodItemIcon} type={item.icon} />
              <div className={styles.methodItemName}>{item.name}</div>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
};

export default Index;
